export const convertToFormattedId = (rawId: string) =>
  rawId.replace(/^(.{4})(.{4})(.{4})(.+)/g, "$1-$2-$3-$4");
